import axios from 'axios'
import store from '@/store'
import router from '@/router'
import moment from 'moment'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.defaults.headers.common['Accept'] = 'application/json'

axios.interceptors.request.use(async (config) => {
  // Refresh token, if near expiration
  // console.log(! store.getters['wait/is']('refreshing authentication'), moment().format(), moment(store.getters.expires).subtract(10, 'minutes').format(), moment(store.getters.expires).format(), moment().isBetween(moment(store.getters.expires).subtract(10, 'minutes'), moment(store.getters.expires)))
  // if (! store.getters['wait/is']('refreshing authentication') && store.getters.token && store.getters.expires && moment().isBetween(moment(store.getters.expires).subtract(10, 'minutes'), moment(store.getters.expires))) {
  //   await store.dispatch('refreshAuthentication')
  // }
  // Attach token to requests, if available
  if (store.getters.token) {
    config.headers.common['Authorization'] = `Bearer ${store.getters.token}`
  }
  // Convert FormData to JSON string
  if (config.data instanceof FormData) {
    var formdata = {}
    config.data.forEach((v, k) => { formdata[k] = v })
    config.data = formdata
  }
  // Laravel spoofs PUT, PATCH, and DELETE requests (see: https://laravel.com/docs/master/routing#form-method-spoofing)
  switch (config.method) {
    case 'post':
    case 'put':
    case 'patch':
    case 'delete':
      config.headers.common['Content-Type'] = 'application/json'
      break
  }
  return config
})

axios.interceptors.response.use((response) => {
  return response
}, (error) => { // Any status codes that falls outside the range of 2xx cause this function to trigger
  if (store.state.wait.waitingFor && store.state.wait.waitingFor.length) { // End all active loaders
    store.state.wait.waitingFor.forEach((loader) => store.dispatch('wait/end', loader, { root: true }))
  }
  switch (error.response.status) {
    case 401: // Unauthorized (https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/401)
      const loginUrl = process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_API_LOGIN_PATH
      if (error.config.url !== loginUrl) {
        store.dispatch('deauthenticate')
          .then(() => {
            router.push({
              path: '/login',
              // query: {
              //   r: window.btoa(`${ window.location.pathname }${ window.location.search }`)
              // }
            })
          })
        return Promise.reject(error)
      }
      break
      default:
          return Promise.reject(error)
  }
})
